import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function PrivateRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        height: '100vh', background: '#080F1A',
        color: '#C9A84C', fontFamily: 'Rajdhani, sans-serif',
        fontSize: '20px', letterSpacing: '0.1em'
      }}>
        LOADING...
      </div>
    );
  }

  return user ? children : <Navigate to="/login" replace />;
}